/* eslint-disable @typescript-eslint/no-non-null-assertion */
// eslint-disable-next-line no-restricted-imports

import React from 'react';
import { default as ReactResponsive } from 'react-responsive';
import { breakpoints } from '@99designs/emu/settings';

type Breakpoint = 'small' | 'medium' | 'normal' | 'large';
interface Props {
    min?: Breakpoint;
    max?: Breakpoint;
    children: React.ReactNode;
}

function Responsive({ min, max, children }: Props) {
    const sizes: { minWidth?: number; maxWidth?: number } = {};

    if (min) {
        sizes.minWidth = breakpoints[min][0]!;
    }

    if (max) {
        sizes.maxWidth = breakpoints[max][1]!;
    }

    return <ReactResponsive {...sizes}>{children}</ReactResponsive>;
}

export default Responsive;
